import { render, staticRenderFns } from "./RuleGroupList.vue?vue&type=template&id=6acd1a0c&scoped=true"
import script from "./RuleGroupList.vue?vue&type=script&lang=js"
export * from "./RuleGroupList.vue?vue&type=script&lang=js"
import style0 from "./RuleGroupList.vue?vue&type=style&index=0&id=6acd1a0c&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6acd1a0c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre环境/快递系统/快递前端/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6acd1a0c')) {
      api.createRecord('6acd1a0c', component.options)
    } else {
      api.reload('6acd1a0c', component.options)
    }
    module.hot.accept("./RuleGroupList.vue?vue&type=template&id=6acd1a0c&scoped=true", function () {
      api.rerender('6acd1a0c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sorting/RuleGroupList.vue"
export default component.exports